export enum VacancyType {
    ForRecruiters = 'forRecruiters',
    ForWorkers = 'forWorkers',
}

export enum VacancySuitableFor {
    Man = 'suitableForMen',
    Woman = 'suitableForWomen',
    Couple = 'suitableForCouple',
    Student = 'suitableForStudents',
}

export enum VacancyTableFilter {
    All = 'all',
    Active = 'active',
    Closed = 'closed',
}
